module.exports = __webpack_public_path__ + "548de6a81e06b29868f44c3750b3a3f1.png";